export default __webpack_public_path__ + "img/airtel.6df94f1d.png";